import { HttpClientAdapter } from '@/graphql/http-client-adapter';
import { REQUEST_LOGIN_LINK, VERIFY_CODE_TOKEN, VERIFY_LINK_TOKEN } from '../../graphql';
import { RequestLoginLinkOutput, VerifyLoginOutput } from '../../types/passwordless-login.types';

const unauthenticated = { requiredAuth: false as const };

export class VerificationTokenRepo {
  async requestLink(identifier: string): Promise<RequestLoginLinkOutput> {
    return HttpClientAdapter.mutate<RequestLoginLinkOutput>(
      {
        mutation: REQUEST_LOGIN_LINK,
        variables: { input: { identifier } },
        dataKey: 'VerificationToken_requestLink',
      },
      unauthenticated,
    );
  }

  async verifyLinkToken(token: string, subjectId?: string): Promise<VerifyLoginOutput> {
    return HttpClientAdapter.mutate<VerifyLoginOutput>(
      {
        mutation: VERIFY_LINK_TOKEN,
        variables: {
          input: subjectId ? { token, subjectId } : { token },
        },
        dataKey: 'VerificationToken_verifyLinkToken',
      },
      unauthenticated,
    );
  }

  async verifyCodeToken(
    requestId: string,
    code: string,
    subjectId?: string,
  ): Promise<VerifyLoginOutput> {
    return HttpClientAdapter.mutate<VerifyLoginOutput>(
      {
        mutation: VERIFY_CODE_TOKEN,
        variables: {
          input: subjectId ? { requestId, code, subjectId } : { requestId, code },
        },
        dataKey: 'VerificationToken_verifyCodeToken',
      },
      unauthenticated,
    );
  }
}

export const verificationTokenRepo = new VerificationTokenRepo();
